var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactElementFactory } from "./element-factory";
import { SurveyQuestionSelectBaseItem, SurveyQuestionSelectbase } from "./reactquestion_selectbase";
var SurveyQuestionCheckbox = /** @class */ (function (_super) {
    __extends(SurveyQuestionCheckbox, _super);
    function SurveyQuestionCheckbox(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionCheckbox.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionCheckbox.prototype.renderHeader = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("legend", { className: "sv-hidden" }, this.question.locTitle.renderedHtml),
            this.getHeader());
    };
    SurveyQuestionCheckbox.prototype.getHeader = function () {
        var _this = this;
        if (this.question.hasHeadItems) {
            return this.question.headItems.map(function (item, ii) {
                return _this.renderItem(item, false, _this.question.cssClasses);
            });
        }
        return null;
    };
    return SurveyQuestionCheckbox;
}(SurveyQuestionSelectbase));
export { SurveyQuestionCheckbox };
var SurveyQuestionCheckboxItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionCheckboxItem, _super);
    function SurveyQuestionCheckboxItem(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionCheckboxItem.prototype.doOnItemChange = function (event) {
        this.question.clickItemHandler(this.item, event.target.checked);
    };
    SurveyQuestionCheckboxItem.prototype.renderElementContent = function () {
        var isChecked = this.question.isItemSelected(this.item);
        return this.renderCheckbox(isChecked);
    };
    Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "inputStyle", {
        get: function () {
            return null; //{ marginRight: "3px" };
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionCheckboxItem.prototype.renderCheckbox = function (isChecked) {
        var id = this.question.getItemId(this.item);
        var itemClass = this.question.getItemClass(this.item);
        var labelClass = this.question.getLabelClass(this.item);
        var itemLabel = !this.hideCaption ? React.createElement("span", { className: this.cssClasses.controlLabel }, this.renderLocString(this.item.locText, this.textStyle)) : null;
        return (React.createElement("div", { className: itemClass, role: "presentation", ref: this.rootRef },
            React.createElement("label", { className: labelClass },
                React.createElement("input", { className: this.cssClasses.itemControl, type: "checkbox", name: this.question.name + this.item.id, value: this.item.value, id: id, style: this.inputStyle, disabled: !this.question.getItemEnabled(this.item), readOnly: this.question.isReadOnlyAttr, checked: isChecked, onChange: this.handleOnChange, required: this.question.hasRequiredError(), "aria-label": this.ariaLabel }),
                this.cssClasses.materialDecorator ?
                    React.createElement("span", { className: this.cssClasses.materialDecorator }, this.question.itemSvgIcon ?
                        React.createElement("svg", { className: this.cssClasses.itemDecorator },
                            React.createElement("use", { xlinkHref: this.question.itemSvgIcon })) :
                        null) :
                    null,
                itemLabel)));
    };
    return SurveyQuestionCheckboxItem;
}(SurveyQuestionSelectBaseItem));
export { SurveyQuestionCheckboxItem };
ReactElementFactory.Instance.registerElement("survey-checkbox-item", function (props) {
    return React.createElement(SurveyQuestionCheckboxItem, props);
});
ReactQuestionFactory.Instance.registerQuestion("checkbox", function (props) {
    return React.createElement(SurveyQuestionCheckbox, props);
});
